<template>
  <section class="edit-profile-section">
    <div class="display-picture-container">
      <div
        @click="openFileUpload"
        class="display-picture"
        @mouseenter="isOverlay = true"
        @mouseleave="isOverlay = false"
      >
        <img :src="form.image_url" alt="" v-if="form.image_url" />
        <img src="/img/user-placeholder.png" alt="" v-else />
        <div class="edit-overlay" :class="isOverlay ? 'hover' : ''">
          <font-awesome-icon icon="camera"></font-awesome-icon>
        </div>
        <input
          type="file"
          id="FileUpload"
          style="display: none"
          @change="uploadPhoto"
          accept="image/*"
        />
      </div>
    </div>
    <h1 class="heading squiggly-line-color line-center">Edit Profile</h1>
    <div class="form-block">
      <b-form data-vv-scope="edit">
        <b-row>
          <b-col cols="6">
            <b-form-group
              id="input-group-2"
              label="Your Name"
              label-for="input-2"
            >
              <b-form-input
                id="input-2"
                v-model.trim="form.name"
                required
                placeholder="Name"
                v-validate="'required|max:20|min:3|alpha_spaces'"
                name="Name"
                :class="{ 'is-invalid': errors.has('edit.Name') }"
              ></b-form-input>
              <font-awesome-icon :icon="['far', 'edit']"></font-awesome-icon>
              <b-form-invalid-feedback id="input-1-live-feedback">
                <small>{{ errors.first("edit.Name") }}</small>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              id="input-group-1"
              label="Email address"
              label-for="input-1"
              description=""
            >
              <b-form-input
                id="input-1"
                v-model="form.email"
                type="email"
                required
                disabled
                placeholder="Email"
              ></b-form-input>
              <!--<font-awesome-icon :icon="['far', 'edit']"></font-awesome-icon>-->
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group id="input-group-3" label="Phone" label-for="input-3">
              <b-form-input
                id="input-3"
                v-model="form.mobile_number"
                required
                disabled
                placeholder="Mobile Number"
              ></b-form-input>
              <!--<font-awesome-icon :icon="['far', 'edit']"></font-awesome-icon>-->
            </b-form-group>
          </b-col>
          <!--<b-col cols="6">-->
          <!--<b-form-group id="input-group-4" label="Class" label-for="input-4">-->
          <!--<b-form-input-->
          <!--id="input-4"-->
          <!--v-model="form.class"-->
          <!--required-->
          <!--placeholder="Class"-->
          <!--&gt;</b-form-input>-->
          <!--<font-awesome-icon :icon="['far', 'edit']"></font-awesome-icon>-->
          <!--</b-form-group>-->
          <!--</b-col>-->
          <!--<b-col cols="6">-->
          <!--<b-form-group-->
          <!--id="input-group-5"-->
          <!--label="Syllabus"-->
          <!--label-for="input-5"-->
          <!--&gt;-->
          <!--<b-form-input-->
          <!--id="input-5"-->
          <!--v-model="form.syllabus"-->
          <!--required-->
          <!--placeholder="Syllabus"-->
          <!--&gt;</b-form-input>-->
          <!--<font-awesome-icon :icon="['far', 'edit']"></font-awesome-icon>-->
          <!--</b-form-group>-->
          <!--</b-col>-->
          <b-col cols="6">
            <b-form-group
              id="input-group-6"
              label="Location"
              label-for="input-6"
            >
              <b-form-input
                id="input-6"
                v-model="form.location"
                required
                placeholder="Location"
                v-validate="'required|alpha|min:3'"
                name="Location"
                :class="{
                  'is-invalid': errors.has('edit.Location')
                }"
              ></b-form-input>
              <font-awesome-icon :icon="['far', 'edit']"></font-awesome-icon>
              <b-form-invalid-feedback id="input-8-live-feedback">
                <small>{{ errors.first("edit.Location") }}</small>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <!--<h4 class="mt-4 text-center small-heading">Edit Interests</h4>-->
        <!--<div class="interest-section">-->
        <!--<div v-for="intrest in intrests" :key="intrest" class="interest-item">-->
        <!--<span>{{ intrest }}</span>-->
        <!--<font-awesome-icon icon="window-close"></font-awesome-icon>-->
        <!--</div>-->
        <!--<b-button variant="primary" size="sm">-->
        <!--<font-awesome-icon icon="plus"></font-awesome-icon>-->
        <!--</b-button>-->
        <!--</div>-->
        <div class="form-bottom">
          <b-button
            size="lg"
            pill
            variant="primary"
            type="submit"
            @click.prevent="action('edit')"
            :disabled="disableButton"
          >
            <span>Save Changes</span>
            <font-awesome-icon icon="arrow-right" size="xs" />
          </b-button>
          <b-button @click="cancel" variant="link">Cancel Changes</b-button>
        </div>
      </b-form>
    </div>
  </section>
</template>

<script>
import { teacherApi } from "../services/teacherApi";
import { mapGetters } from "vuex";
import { customerApi } from "../services/customerApi";

export default {
  name: "EditProfile",
  data() {
    return {
      isOverlay: false,
      form: {
        email: "",
        name: "",
        phone: "",
        class: "",
        syllabus: "",
        location: "",
        image_url: ""
      },
      foods: [
        { text: "Select One", value: null },
        "Carrots",
        "Beans",
        "Tomatoes",
        "Corn"
      ],
      showEditError: false,
      disableButton: false,
      intrests: ["Music", "Painting", "Research"]
    };
  },
  computed: {
    ...mapGetters("user", ["getUserDetails", "getUserRole"])
  },
  methods: {
    action(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.showEditError = false;
          this.editUserDetails();
        } else {
          this.showEditError = true;
        }
      });
    },
    openFileUpload() {
      const fileUpload = document.getElementById("FileUpload");
      fileUpload.click();
    },
    uploadPhoto(event) {
      this.disableButton = true;
      this.imageFile = event.target.files[0];
      const formData = new FormData();
      formData.append("document", this.imageFile);
      teacherApi.uploadResume(formData).then(res => {
        this.form.image_url = res.bodyText;
        this.disableButton = false;
      });
    },
    resetData() {
      this.form.email = this.getUserDetails.email;
      this.form.name = this.getUserDetails.name;
      this.form.mobile_number = this.getUserDetails.phone;
      this.form.location = this.getUserDetails.location;
      this.form.image_url = this.getUserDetails.profile_photo;
    },
    editUserDetails() {
      const userData = {
        name: this.form.name,
        location: this.form.location,
        profile_photo: this.form.image_url,
        email: this.form.email,
        role: this.getUserRole
      };
      customerApi
        .editCustomerDetails(userData)
        .then(() => {
          customerApi.getCustomerDetails(this.getUserRole);
          this.$bvToast.toast(`Profile Updated successfully`, {
            title: "Edit Profile",
            autoHideDelay: 500,
            appendToast: true
          });
          setTimeout(() => {
            this.$router.push({
              path: "/student/dashboard",
              query: {
                role: this.getUserRole
              }
            });
          }, 500);
        })
        .catch(() => {
          this.$bvToast.toast(`Profile Update Failed`, {
            title: "Edit Profile",
            autoHideDelay: 500,
            appendToast: true
          });
        });
    },
    cancel() {
      this.resetData();
      this.$router.push({
        path: "/student/dashboard",
        query: {
          role: this.getUserRole
        }
      });
    }
  },
  mounted() {
    this.resetData();
  }
};
</script>
